module.exports = __webpack_public_path__ + "src/assets/img/share-qq.935e56e0.png";